import { Badge } from "@pushpress/pushpress-ui";
import { LEAD_STATUS_VARIANTS, MEMBER_STATUS_VARIANTS } from "../../constants";
import { getStatusFormat } from "../../helpers";
import {
  LeadStatusType,
  PeopleType,
  PEOPLE_TYPE,
  SubscriptionStatusType,
} from "../../types";

export default function StatusBadge({
  peopleType,
  status,
  isMobile = false,
}: {
  peopleType: PeopleType;
  status: LeadStatusType | SubscriptionStatusType;
  isMobile?: boolean;
}) {
  if (peopleType === PEOPLE_TYPE.MEMBERS) {
    const statusVariant =
      MEMBER_STATUS_VARIANTS[status] || MEMBER_STATUS_VARIANTS.default;
    return (
      <Badge variant={statusVariant} size={isMobile ? "sm" : "default"}>
        {getStatusFormat(status)}
      </Badge>
    );
  }

  if (peopleType === PEOPLE_TYPE.LEADS) {
    const statusVariant =
      LEAD_STATUS_VARIANTS[status] || LEAD_STATUS_VARIANTS.default;
    return (
      <Badge variant={statusVariant} size={isMobile ? "sm" : "default"}>
        {getStatusFormat(status)}
      </Badge>
    );
  }

  return "--";
}
